import { render, staticRenderFns } from "./user-auth.vue?vue&type=template&id=51ac2526&"
import script from "./user-auth.vue?vue&type=script&lang=ts&"
export * from "./user-auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports